export default [
  {
    path: '/mobile/my/update-user-info',
    name: 'mobile-my-update-user-info',
    component: () => import('@/views/mobile/my/UpdateUserInfo.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '编辑资料',
    },
  },
  {
    path: '/mobile/my/update-text-item',
    name: 'mobile-my-update-text-item',
    component: () => import('@/views/mobile/my/UpdateTextItem.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '修改资料明细项',
    },
  },
  {
    path: '/mobile/my/update-user-phone',
    name: 'mobile-my-update-user-phone',
    component: () => import('@/views/mobile/my/UpdateUserPhone.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '修改手机号',
    },
  },
  {
    path: '/mobile/my/bind-account-wechat',
    name: 'mobile-my-bind-account-wechat',
    component: () => import('@/views/mobile/my/BindAccountWechat.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '绑定微信',
    },
  },
  {
    path: '/mobile/my/update-password',
    name: 'mobile-my-update-password',
    component: () => import('@/views/mobile/my/UpdatePassword.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '修改密码',
    },
  },
  {
    path: '/mobile/my/setting',
    name: 'mobile-my-setting',
    component: () => import('@/views/mobile/my/Setting.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '设置',
    },
  },
  {
    path: '/mobile/my/setting/helper-doc',
    name: 'mobile-my-setting-helper-doc',
    component: () =>
      import('@/views/empty/helper-doc/helper-doc/HelperDocMobile.vue'), // 该组件同时适用于移动端和非移动端多套路由地址
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '帮助文档',
    },
  },
];
